import styled from "styled-components"
import { Main } from "../shared/StylePage"
import mark from '../img/Redorn/mark.png'

/*const Stripe = styled.div`
    @media(width > 1440px){
        width: 1715px;
    }
    position: absolute;
    width: 1440px;
    height: 51px;
    background-color: #272727;
    top: 639px;
    left: 0;
    z-index: 2;
`*/
const Link = styled.a`
    text-decoration: none;
    color: #272727;
    transform: translate(-4px, 15px) rotate(-8deg);
    @keyframes shake-circle-01 {
        0% { transform: translate(-8px, -14px); }
        33% { transform: translate(-10px, -14px); }
        66% { transform: translate(-10px, -16px); }
        100% { transform: translate(-8px, -16px); }
    }
    &:hover{
        opacity: 1; transform: scale(1); transition-delay: 0ms, 0ms;
        animation: shake-circle-01 .6s infinite alternate;
    }
`
const DivCities = styled.div`
    display: flex;
    justify-content: space-between;
    
    margin-top: 50px;
    visibility: hidden;
    & > * {
        visibility: visible;
        transition: opacity 100ms linear 100ms, transform 100ms ease-in-out 100ms;
        z-index: 10;
        opacity: 1; 
        transform: scale(0.9);
    }
    &:hover  {

    } 
    @media(width <= 1200px){
        flex-wrap: wrap;
    }
`
const DivCity = styled.div`
    width: 310px;
    height: 200px;
    border: 3px solid #272727;
    border-radius: 10px;
    background-color: #FFFFFF;
    position: relative;
    z-index: 10;
    box-sizing: border-box;
    padding: 12px 0px 0px 19px; 
    
`
const TextData = styled.p`
    font-size: 23px;
    margin: 0 0;
`
const DivImg = styled.div`
    display: flex;
    justify-content: center;
    padding-top: 28px;
    padding-bottom: 5px;
`
const TextCity = styled.p`
    font-size: 23px;
    margin: 0 0;
    text-align: center;
`
export const Slider = () => {
    const cities =[
        {
            city:'Воткинск',
            data: '7 АПРЕЛЯ',
            textlink: 'https://forms.yandex.ru/u/67c7f805e010db218234f563/'
        },
        {
            city:'Можга',
            data: '15 АПРЕЛЯ',
            textlink: 'https://forms.yandex.ru/cloud/67c6e030493639b97b4db951/'
        },
        {
            city:'Сарапул',
            data: '23 АПРЕЛЯ',
            textlink: 'https://forms.yandex.ru/cloud/67c80dcaf47e73219c82ce28/'
        },
        {
            city:'Глазов',
            data: '18 АПРЕЛЯ',
            textlink: 'https://forms.yandex.ru/u/67ce9412068ff0b40ba70a61/'
        },
    ]
    return(
        <Main id="s2" wrap='wrap'>
            
            <DivCities>
                {cities.map((e)=>{
                    return(
                            <Link href={e.textlink}>
                                <DivCity>                                    
                                    <TextData>{e.data}</TextData>
                                    <DivImg>
                                        <img src={mark} alt="" />
                                    </DivImg>
                                    <TextCity>{e.city}</TextCity>                                
                                </DivCity>
                            </Link>
                    )
                })}
            </DivCities>
            
        </Main>
    )
}